// Bộ trường hồ sơ khách, khai một chỗ.
//
// Khai bằng dữ liệu chứ không rải trong template vì bộ trường này còn dùng lại
// ở chỗ khác (xuất báo cáo, màn Danh bạ), và vì thứ tự các trường là quyết định
// nghiệp vụ — sửa nó không nên phải đọc template.
//
// Tất cả lưu trong custom_attributes của khách với tiền tố kh_. Không dựng kho
// riêng: Chatwoot lọc và xuất được ngay, còn dịch vụ CRM vốn nhận webhook của
// Chatwoot nên sau này tự nhặt được, không phải chuyển dữ liệu.

/**
 * Các trường người trực nhập, đúng thứ tự hiện trong tab Thông tin.
 * Có `chon` thì vẽ thành ô chọn. Bề rộng mỗi ô do tab Thông tin quyết định
 * theo khoá, xem bảng BE_RONG trong BonbozContactInfo.vue.
 *
 * Khách mới / cũ đang nhập tay. Khi nối ERP thì ERP mới là nguồn đúng, lúc đó
 * nên chuyển ô này sang chỉ đọc chứ không để hai nơi cùng ghi.
 */
export const TRUONG_NHAP = [
  {
    khoa: 'kh_gioi_tinh',
    nhan: 'GIOI_TINH',
    chon: ['', 'Nữ', 'Nam', 'Khác'],
  },
  {
    khoa: 'kh_tuoi',
    nhan: 'TUOI',
    so: true,
  },
  {
    khoa: 'kh_dia_chi',
    nhan: 'DIA_CHI',
  },
  {
    khoa: 'kh_loai_khach',
    nhan: 'LOAI_KHACH',
    chon: ['', 'Khách mới', 'Khách cũ'],
  },
  {
    khoa: 'kh_trang_thai',
    nhan: 'TRANG_THAI',
    chon: ['', 'Mới', 'Đang tư vấn', 'Đã hẹn', 'Đã đến', 'Im'],
  },
];

/**
 * Trả về tuổi hợp lệ, hoặc chuỗi rỗng.
 *
 * Chặn ở đây chứ không ở ô nhập vì luật này còn dùng khi nhận dữ liệu từ nơi
 * khác đổ vào. Quá 120 gần như chắc chắn là nhập nhầm năm sinh vào ô tuổi.
 */
export const tuoiHopLe = giaTri => {
  const n = parseInt(giaTri, 10);
  return n > 0 && n < 120 ? String(n) : '';
};

/**
 * Dịch vụ khách quan tâm, đọc từ thẻ chứ không có ô nhập riêng.
 *
 * Người trực đã gắn thẻ dịch vụ ngay dưới khung chat; bắt nhập lại lần thứ hai
 * vào một ô khác thì không ai nhập, và hai nơi sẽ lệch nhau ngay tuần đầu.
 *
 * @param {string[]} nhan Danh sách nhãn của hội thoại.
 * @returns {string[]} Các thẻ dịch vụ, giữ nguyên thứ tự đã gắn.
 */
export const dichVuQuanTam = (nhan = []) =>
  (Array.isArray(nhan) ? nhan : []).filter(ten =>
    String(ten).toLowerCase().startsWith('dv_')
  );

/** Giá trị đang lưu của một trường, luôn trả về chuỗi để gắn vào ô nhập. */
export const giaTri = (contact, khoa) =>
  String((contact?.custom_attributes || {})[khoa] ?? '');
